import { DEFAULT_LOCALE, type Locale } from './config';
import type { LocaleCopy } from './types';
import { en } from './en';
import { de } from './de';
import { es } from './es';
import { fr } from './fr';
import { it } from './it';
import { ro } from './ro';

export const COPY: Partial<Record<Locale, LocaleCopy>> = { en, de, es, fr, it, ro };

export function getCopy(locale: Locale): LocaleCopy {
  return COPY[locale] ?? (COPY[DEFAULT_LOCALE] as LocaleCopy);
}
